export const formatToCurrencyString = (
  price: number,
  {
    currency = "GBP",
    compact = false,
    decimals = true,
  }: {
    currency?: string
    compact?: boolean
    decimals?: boolean
  } = {}
): string => {
  const localeBcp47 = "en-GB"
  return new Intl.NumberFormat(localeBcp47, {
    style: "currency",
    currency: currency,
    ...(compact && {
      notation: "compact",
      maximumFractionDigits: decimals ? 2 : 0,
    }),
  }).format(price / 100)
}
